// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iXOr9","index":"styles_index__3Vbfy"};